import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // استيراد مكون App الرئيسي
import '@fortawesome/fontawesome-free/css/all.css';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App /> {/* عرض مكون App */}
  </React.StrictMode>
);